<template>
    <div id="Home">
        <!-- <div class="select">
            <div class="select_item" v-for="item in mapList" :key="item.index" @click.stop="changeList(item)">
                <p class="name" :class="item.type == currenIndex ? 'active' : ''">{{ item.name }}</p>
            </div>
        </div>
        <component :is="currenIndex" v-cloak /> -->
        <ul class="ul_title">
            <li v-for="(item, index) in subList" :key="index">
                <div class="li_title" v-if="item.subs">
                    <p class="top_title">{{ item.title }}</p>
                    <ul v-if="item.subs" class="subs_title">
                        <li v-for="(ite, inde) in item.subs" :key="inde" class="subs_li" @click="goIndex(ite)">
                            <p :class="icon_p + inde%5" class="icon_p">
                                <i :class="ite.icon" class="iteIcon"></i>
                            </p>
                            <span>{{ ite.title }}</span>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
// import sctterMap from '../page/map/sctterMap.vue';
// import dotMap from '../page/map/dotMap.vue';
// import heatMap from '../page/map/heatMap.vue';
// import allMap from '../page/map/allMap.vue';
export default {
    name: 'dashboard',
    components: {
        // sctterMap,
        // dotMap,
        // heatMap,
        // allMap
    },
    data() {
        return {
            // currenIndex: 'allMap',
            // mapList: [
            //     {
            //         type: 'allMap',
            //         name: '综合地图',
            //         index: 4
            //     },
            //     {
            //         type: 'sctterMap',
            //         name: '分布图',
            //         index: 1
            //     },
            //     {
            //         type: 'heatMap',
            //         name: '热力图',
            //         index: 2
            //     },
            //     {
            //         type: 'dotMap',
            //         name: '散点图',
            //         index: 3
            //     }
            // ],
            subList: [],
            list: [],
            icon_p: 'icon_p'
        };
    },
    mounted() {
        let temp = JSON.parse(localStorage.getItem('adminMenus'));

        temp.forEach((item) => {
            if (item.subs) {
                let subTemp = [];

                item.subs.forEach((subItem) => {
                    if (subItem.subs) {
                        subItem.subs.forEach((secSubItem) => {
                            subTemp.push(secSubItem);
                        });
                    } else {
                        subTemp.push(subItem);
                    }
                });

                item.subs = subTemp;
                this.subList.push(item);
            }
        });
    },
    methods: {
        changeList(val) {
            if (val.type == this.currenIndex) {
                return;
            }
            this.currenIndex = val.type;
        },
        goIndex(ite) {
            this.$router.push({
                path: ite.index
            });
        }
    }
};
</script>
<style lang="scss" scoped>
#Home {
    width: 100%;
    height: 100%;
    position: relative;
    .select {
        position: absolute;
        left: 1%;
        top: 15%;
        z-index: 15;

        .select_item {
            padding: 6px 25px;
            color: rgb(179, 239, 255);
            background: rgba(147, 235, 248, 0.35);
            border-radius: 15px;
            margin: 25px 0;
            cursor: pointer;

            .active {
                color: rgb(254, 217, 50);
            }
        }
    }
}
.ul_title {
    width: 100%;
    box-sizing: border-box;
    padding: 1px 20px;
    .li_title {
        width: 100%;
        height: auto;
        margin: 10px 0px;
        font-size: 14px;
        .top_title {
            display: inline-block;
            margin: 0px 0 10px 10px;
            font-size: 15px;
        }
        .subs_title {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            border-radius: 5px;
            .subs_li {
                cursor: pointer;
                width: 10.5%;
                height: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;
                line-height: 40px;
                box-sizing: border-box;
                border-radius: 5px;
                padding: 15px 0 0 0;
                box-shadow: 0 1px 6px 0px rgba(0, 0, 0, 0.2);
                margin: 10px;
                .icon_p {
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    border-radius: 5px;
                    .iteIcon {
                        font-size: 27px;
                        color: rgb(247, 248, 247);
                    }
                }
                .icon_p0 {
                    background: #3297fa;
                }
                .icon_p1 {
                    background: #722ed1;
                }
                .icon_p2 {
                    background: #fe7a23;
                }
                .icon_p3 {
                    background: #00b600;
                }
                .icon_p4 {
                    background: #ffc200;
                }
            }
        }
    }
}
</style>